import React, { useState } from "react";
import "./EnergyMonitoringApp.css";

const mockData = [
  {
    id: "1",
    building: 'Офисный комплекс "Север"',
    serial: "EVSE-SER-2024-001",
    counter: "MTR-2024-789456",
    spotId: 1,
    status: "available",
    progress: 0,
    consumption: 0,
    reading: 1245.6,
  },
  {
    id: "2",
    building: 'Офисный комплекс "Север"',
    serial: "EVSE-SER-2024-001",
    counter: "MTR-2024-789456",
    spotId: 2,
    status: "charging",
    progress: 65,
    consumption: 32.4,
    reading: 2156.8,
  },
];

const getStatusColor = (status) => {
  const colors = {
    available: "#10b981",
    charging: "#3b82f6",
    occupied: "#f59e0b",
    completed: "#8b5cf6",
    error: "#ef4444",
    unavailable: "#6b7280",
  };
  return colors[status] || colors.unavailable;
};

const EnergyMonitoringApp = () => {
  const [running, setRunning] = useState({});

  const toggle = (id) => {
    setRunning((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="mobile-wrapper">
      {/* Шапка */}
      <header className="app-header">
        <div className="header-user">
          <div className="header-avatar">АК</div>
          <span className="header-name">Алексей</span>
        </div>
        <button className="header-exit">Выйти</button>
      </header>

      {/* Карточки */}
      {mockData.map((item) => (
        <div key={item.id} className="card-demo">
          <div className="status">
            <div
              className="status-dot"
              style={{ backgroundColor: getStatusColor(item.status) }}
            />
            <span>
              {item.status === "available" && "Свободно"}
              {item.status === "charging" && "Заряжается"}
              {item.status === "occupied" && "Занято"}
              {item.status === "completed" && "Заряжено"}
              {item.status === "error" && "Ошибка"}
            </span>
          </div>
          <div className="card-title">{item.building}</div>
          <div className="card-meta">
            <div>
              Серийный №: <strong>{item.serial}</strong>
            </div>
            <div>
              Счётчик №: <strong>{item.counter}</strong>
            </div>
          </div>

          <div className="card-row">
            <div>Место #{item.spotId}</div>
          </div>

          <div className="metrics">
            <div className="metrics-item">
              <div className="metric-label">Потребление</div>
              <div className="metric-value">{item.consumption} А</div>
            </div>
            <div className="metrics-item">
              <div className="metric-label">Показания</div>
              <div className="metric-value">{item.reading} кВт·ч</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EnergyMonitoringApp;
